export const USAGE_DIALOG_TABLE_HEIGHT = "200px";
export const USAGE_DIALOG_WIDTH = "850px";

export const USAGE_ROW_ACTIONS = Object.freeze({
  OPEN: "open",
  DELETE: "delete",
});
